import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import { createPinia } from 'pinia'
import './styles/global.scss'
import 'v-calendar/dist/style.css'
import { initializeLocale, installI18n } from './i18n'
import { initializeOAuthService } from './services/oauthService'

declare global {
  interface Window {
    __NWLANG?: string
  }
}

const lang = window.__NWLANG || localStorage.getItem('userLanguage') || 'no'
initializeLocale(lang)

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
installI18n(app)

initializeOAuthService()
app.mount('#app')
